(function ($) {
    'use strict';

    /**
     * ПопапАвторизации
     */
    $.fn.authPopup = function () {
        const $self = $(this);
        const $overlay = $self.closest('.js-popup-auth-overlay');
        const $buttonTogglePassword = $self.find('.js-toggle-password');
        const $buttonClearInput = $self.find('.js-clear-button');
        let $input = $self.find('.js-input-popup-auth');


        /**
         * Очищает input 
         * @param {jQueryObject} input 
         */
        const clearInput = (input) => $(input).val('');


        /**
         * Открывает попап
         */
        const openPopup = () => {
            $overlay.addClass('opened')
            SVK.makeFixedHtml();
        };


        /**
         * Закрывает попап
         */
        const closePopup = function () {
            $overlay.removeClass('opened');
            $input.each(function (index, el) {
                clearInput($(el));
                $(el).closest('.js-field').removeClass('has-focus');
            });
            SVK.makeUnfixedHtml();
        };

        /**
         * Переключает видимость пароля
         */
        const togglePasswordVisibility = function () {
            let $inputPassword = $self.find('#password_input');
            let $currentType = $inputPassword.attr('type');

            $inputPassword.attr('type', $currentType === 'text' ? 'password' : 'text');

            if ($inputPassword.attr('type') === 'password') {
                $buttonTogglePassword.removeClass('password-visible').addClass('password-hidden');
            } else {
                $buttonTogglePassword.removeClass('password-hidden').addClass('password-visible');
            }
        };


        /**
         * Инициализации событий
         */
        const initEvents = function () {
            $(document).on('click', '.js-popup-auth-open', openPopup);
            $(document).on('click', '.js-close-button-authorization', closePopup);
            $overlay.on('click', function (e) {
                if ($(e.target).is($overlay)) {
                    closePopup();
                }
            });

            $input.each(function (index, el) {
                let $inputHolder = $(el).closest('.js-field');
                $(el).on('focus', function () {
                    $inputHolder.addClass('has-focus');
                });

                $(el).on('blur', function () {
                    if (!$(el).val()) {
                        $inputHolder.removeClass('has-focus');
                    }
                });
            });

            $buttonTogglePassword.on('click', function (e) {
                e.preventDefault();
                togglePasswordVisibility();
            });

            $buttonClearInput.on('click', function (e) {
                e.preventDefault();
                let $inputHolder = $(e.target).closest('.js-field');
                let $inputForClear = $inputHolder.find('.js-input-popup-auth');
                $inputForClear.focus();
                clearInput($inputForClear);
            });
        };

        /**
         * Инициализации плагина
         */
        const init = function () {

            initEvents();
        };

        init();

        return this;
    }

})(jQuery);